<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
<!--          <a-col :span="24">
            <a-form-model-item :label="商品" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="product">
              <a-input v-model="model.product" :placeholder="language['common.pleaseInput']+商品"  ></a-input>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="8">
            <a-form-model-item :label="language['gift_product_code']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"  prop="productCode" >
              <a-input-search
                v-model="model.productCode"
                :placeholder="language['common.pleaseInput']+language['gift_product_code']"
                style="width: 200px"
                @keydown.enter='onSearch'
                @search="onSearch"
                :maxLength='30'
                :disabled='productCodeDisable'
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="16">
            <a-form-model-item :label="language['gift_product_name']"
                               :labelCol="labelCol3"
                               :wrapperCol="wrapperCol2"
                               prop="name">
              <a-input v-model="model.productName"
                       placeholder="" disabled></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="language['gift_user_app']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="app">
              <a-input v-model="model.appName" disabled />
            </a-form-model-item>
          </a-col>

          <a-col :span="8">
            <a-form-model-item :label="language['gift_product_vendor']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="supplier">
              <a-input v-model="model.supplierName" disabled />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="language['gift_merchant_name']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="supplier">
              <a-input v-model="model.businessName" disabled />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="language['gift_product_price']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="price">
              <a-input v-model="model.price" :placeholder="language['common.pleaseInput']+language['gift_product_price']" disabled/>
            </a-form-model-item>
          </a-col>

          <a-col :span="6">
            <a-form-model-item :label="language['gift_product_limit']"
                               :labelCol="labelCol">
              <a-switch v-model='model.limited > 0' disabled ></a-switch>
              <a-input v-model="model.limited " v-show='model.limited > 0 '  :disabled="disabled" style="width: 57%;margin-left: 10px;" disabled ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="language['gift_app_up_down']" :labelCol="labelCol2" :wrapperCol="wrapperCol" style="margin-left: 20px;">
              <a-switch v-model="model.status === 1" disabled></a-switch>
            </a-form-model-item>
          </a-col>

          <a-col :span="6">
            <a-form-model-item :label="language['gift_product_virtual']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="virtual">
              <a-switch v-model="model.virtual === 1" disabled></a-switch>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane :tab="'*' + language['gift_product_stock']" :key="refKeys[0]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[0]"
          :loading="productStockTable.loading"
          :columns="productStockTable.columns"
          :dataSource="productStockTable.dataSource"
          :maxHeight="300"
          :rowNumber="true"
          :disabled='formDisabled'
          :rowSelection="false"
          :actionButton="false">
        </j-editable-table>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

import { httpAction, getAction, postAction } from '@api/manage'
  import { validateDuplicateValue } from '@/utils/util'
import { FormTypes, getRefPromise, VALIDATE_NO_PASSED, validateFormModelAndTables } from '@/utils/JEditableTableUtil'
import { JEditableTableModelMixin } from '@/mixins/JEditableTableModelMixin'

  export default {
    name: 'ProductStockForm',
    mixins: [JEditableTableModelMixin],
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      const { language } = this.$store.getters;
      return {
        productCodeDisable:false,
        model:{
          productStockList:[]
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        labelCol3: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 19 },
        },
        productList:[],
        refKeys: ['productStockTable', ],
        tableKeys:['productStockTable', ],
        activeKey: 'productStockTable',
        confirmLoading: false,
        productStockTable: {
          loading: false,
          dataSource: [],
          columns:[],
          columns1: [
            {
              title: language['gift_product_weekly'],
              key: 'appDeliveryTime',
              type: FormTypes.input,
              width:"300px",
              disabled:true,
              placeholder: '请输入${title}'
            },
            {
              title: language['gift_product_total_stock'],
              key: 'stock',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: '请输入${title}',
              defaultValue:'',
              validateRules: [
                // { pattern: /^(0)|([1-9]\d{0,9})$/,required: true, message: '${title}不能为空' },
                   { value: 'z', pattern: /^-?\d+$/ ,required: true, message: '${title}不能为空' },
              ],
            },
          ],
          columns2: [
            {
              title: language['gift_product_weekly'],
              key: 'appDeliveryTime',
              type: FormTypes.input,
              width:"300px",
              disabled:true,
              placeholder: '请输入${title}'
            },
            {
              title: language['gift_product_total_stock'],
              key: 'stock',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: '请输入${title}',
              defaultValue:'',
              validateRules: [
                { pattern: /^(0)|([1-9]\d{0,9})$/,required: true, message: '${title}不能为空' },
              ],
            },
            {
              title: language['gift_product_saled'],
              key: 'saleCount',
              type: FormTypes.input,
              width:"200px",
              disabled:true,
              placeholder: '请输入${title}'
            },
            {
              title: language['gift_product_remaining_stock'],
              key: 'balance',
              type: FormTypes.input,
              width:"200px",
              disabled:true,
              placeholder: '请输入${title}'
            },
          ]
      },
        validatorRules: {
           productCode: [
              { required: true, message: '请输入商品编码!'},
           ]
        },
        url: {
          add: "/gift/stock/productstock",
          edit: "/gift/stock/productstock",
          queryById: "/gift/stock/productstock/",
          queryProductInfo:"/gift/stock/productInfoByCode",
          getProductInfo :"/gift/stock/productInfo"
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      language() {
        return this.$store.getters.language
      },
    },
    created () {
       //备份model原始值
       //this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      productConfig(disable,showMore){
        this.productCodeDisable = disable;
        this.productStockTable.columns = showMore ? this.productStockTable.columns2:this.productStockTable.columns1;
      },
      add () {
        //this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        postAction(this.url.getProductInfo,record).then(res=>{
          if (res.success){
            console.log("record:",record)
            this.productStockTable.dataSource = res.result.productStockList;
            console.log("this.model.status:",this.model.status)
            this.$forceUpdate();
          }
        })
        this.visible = true;
      },
      onSearch(searchValue){
        console.log(searchValue);
        getAction(this.url.queryProductInfo,{"code":searchValue.trim()}).then(res=>{
            console.log(res);
            if (res.success){
               this.model = res.result;
               this.productStockTable.dataSource = res.result.productStockList;
               this.$forceUpdate();
            }else {
              this.$message.error(res.message);
            }
        })
      },
      submitForm () {
        /** 触发表单验证 */
        this.getAllTable().then(tables => {
          /** 一次性验证主表和所有的次表 */
          return validateFormModelAndTables(this.$refs.form,this.model, tables)
        }).then(allValues => {
          /** 一次性验证一对一的所有子表 */
          return this.validateSubForm(allValues)
        }).then(allValues => {
          if (typeof this.classifyIntoFormData !== 'function') {
            throw this.throwNotFunction('classifyIntoFormData')
          }
          let formData = this.classifyIntoFormData(allValues)
          // 发起请求
          const that = this;
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if(!this.productCodeDisable){
            httpurl+=this.url.add;
            method = 'post';
          }else{
            httpurl+=this.url.edit;
            method = 'put';
          }
          httpAction(httpurl,formData,method).then((res)=>{
            if(res.success){
              that.$message.success(res.message);
              that.$emit('ok');
            }else{
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.confirmLoading = false;
          })
        }).catch(e => {
          if (e.error === VALIDATE_NO_PASSED) {
            // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
            //update--begin--autor:liusq-----date:20210316------for：未通过表单验证跳转tab问题------
            this.activeKey = e.index == null ? this.activeKey : (e.paneKey?e.paneKey:this.refKeys[e.index])
            //update--end--autor:liusq-----date:20210316------for：未通过表单验证跳转tab问题------
          } else {
            console.error(e)
          }
        })
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        console.log(allValues,"all")
        return {
          ...main, // 展开
          productStockList: allValues.tablesValue[0].values,
        }
      },

      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      validateError(msg){
        this.$message.error(msg)
      },

      //校验所有一对一子表表单
      validateSubForm(allValues){
        return new Promise((resolve,reject)=>{
          Promise.all([
          ]).then(() => {
            resolve(allValues)
          }).catch(e => {
            if (e.error === VALIDATE_NO_PASSED) {
              // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
              this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
            } else {
              console.error(e)
            }
          })
        })
      },


    }
  }
</script>
